import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import { clearOrderConfirmationSessionAtom } from './order-confirmation-session-atoms';
import type {
  RespondMerchantConfirmationRequest,
  RespondMerchantConfirmationResponse,
} from './types';

import { merchantConfirmationApi } from '../api/merchant-confirmation-api';

export const useConfirmOrder = (options?: { onSuccess?: () => void }) => {
  const clearOrderConfirmationSession = useSetAtom(
    clearOrderConfirmationSessionAtom
  );

  return useMutation<
    RespondMerchantConfirmationResponse,
    Error,
    RespondMerchantConfirmationRequest
  >({
    mutationFn: (data) => merchantConfirmationApi.confirmOrder(data),
    onSuccess: () => {
      clearOrderConfirmationSession();
      options?.onSuccess?.();
    },
  });
};
